export { CREATE_HIGHLIGHT, UPDATE_HIGHLIGHT } from 'pipelines/Highlight/actions';

export const CREATE_NOTETEXT = 'CREATE_NOTETEXT';
export const DEBOUNCE_NOTETEXT = 'DEBOUNCE_NOTETEXT';
export const DELETE_NOTETEXT = 'DELETE_NOTETEXT';
export const TOGGLE_NOTE = 'TOGGLE_NOTE';
